let validPhone = new RegExp(
  //adapted from https://stackoverflow.com/questions/2113908/what-regular-expression-will-match-valid-international-phone-numbers
  //international access code identifiers: +, 0, 00 (optional)
  "^(\\+|0|00)?" +
    //international prefixes (optional)
    "(9[976]\\d|8[987530]\\d|6[987]\\d|5[90]\\d|42\\d|3[875]\\d|2[98654321]\\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)?" +
    //8-10 digits with any separator allowed
    "\\W*\\d\\W*\\d\\W*\\d\\W*\\d\\W*\\d\\W*\\d\\W*\\d\\W*(\\d\\W*)?(\\d{1,2})$"
);

let validShortCode = new RegExp("^[0-9]{5,6}$");

let validUrl = new RegExp(
  "^" +
    // protocol identifier
    "(?:(?:https?|ftp)://)" +
    // user:pass authentication
    "(?:\\S+(?::\\S*)?@)?" +
    "(?:" +
    // IP address exclusion
    // private & local networks
    "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
    "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
    "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
    // IP address dotted notation octets
    // excludes loopback network 0.0.0.0
    // excludes reserved space >= 224.0.0.0
    // excludes network & broacast addresses
    // (first & last IP address of each class)
    "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
    "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
    "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
    "|" +
    // host name
    "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
    // domain name
    "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
    // TLD identifier
    "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
    // TLD may end with dot
    "\\.?" +
    ")" +
    // port number
    "(?::\\d{2,5})?" +
    // resource path
    "(?:[/?#]\\S*)?" +
    "$",
  "i"
);

export const validateHasData = (field) => {
  return field !== undefined && field !== null && field !== "";
};

export const validatePhone = (phoneNumber) => {
  return validPhone.test(phoneNumber);
};

export const validateShortCode = (phoneNumber) => {
  return validShortCode.test(phoneNumber);
};

export const validateEmail = (email) => {
  return email.match(/.+@.+\..+/);
};

export const validateCommaSeparatedEmails = (emails) => {
  return emails.match(/^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/);
};

export const validateUSPostalCode = (postalCode) => {
  return postalCode.match(/^\d{5}(?:[-\s]\d{4})?$/);
};

export const validateCAPostalCode = (postalCode) => {
  return postalCode.match(
    /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
  );
};

export const validatePasswordLowerLetter = (password) => {
  return password.match(/[a-z]+/);
};

export const comparePassword = (password1, password2) => {
  return password1 === password2;
};

export const validatePasswordRules = (password) => {
  /* Match string with 8 to 256 characters and at least two of:
   * 1 lowercase letter
   * 1 uppercase letter
   * 1 digit
   * 1 special character
   */

  const matchTarget = 2;
  const min = 8;
  const max = 256;

  const re_array = [/[A-Z]/, /[a-z]/, /[0-9]/, /[@$!%*?&_]/];

  //length validation
  if (password.length < min || password.length > max) return false;

  // content validation
  let matchCount = 0;
  re_array.forEach((re) => {
    if (re.test(password)) matchCount++;
  });

  return matchCount >= matchTarget;
};

export const validateIfPostalCode = (postalCode) => {
  return postalCode.match(/^\d{5}$/);
};

export const validateAreaCode = (areaCode) => {
  return areaCode.match(/^[^\d]*[0|1]*(\d)[^\d]*(\d)[^\d]*(\d)(.*)$/);
};

export const validateCity = (city) => {
  return city.match(/^([\s\w]*\w+)[,\s]+([A-Z]{2})$/i);
};

export const validateState = (state) => {
  return state.match(/^[A-Z]{2}$/i);
};

export const validateUrl = (url) => {
  return validUrl.test(url);
};

export const isInvalidDate = (date) => {
  return !date || isNaN(date);
};

export const validateNumber = (number) => {
  return number.match(/^\d+$/);
};

export default {
  validateHasData,
  validatePhone,
  validateShortCode,
  validateEmail,
  validateCommaSeparatedEmails,
  validateUSPostalCode,
  validateCAPostalCode,
  validatePasswordLowerLetter,
  comparePassword,
  validatePasswordRules,
  validateIfPostalCode,
  validateAreaCode,
  validateCity,
  validateState,
  validateUrl,
  isInvalidDate,
  validateNumber,
};
